/* tslint:disable */
/* eslint-disable */
/**
 * Eatgrim Shipping API
 * Eatgrim Shipping API
 *
 * The version of the OpenAPI document: 1.0.0
 * Contact: tech@soundsgood.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
/**
 *
 * @export
 * @enum {string}
 */
export var Country;
(function (Country) {
    Country["Dk"] = "DK";
})(Country || (Country = {}));
export function CountryFromJSON(json) {
    return CountryFromJSONTyped(json, false);
}
export function CountryFromJSONTyped(json, ignoreDiscriminator) {
    return json;
}
export function CountryToJSON(value) {
    return value;
}
